import config from '__api/config';
import Mask from '__components/Mask';
import { openUrl } from '__utils/openUrl';
import { EmTouchableOpacity } from 'emrn-design/EmTouchable';
import { LinearGradient } from 'emrn-design/LinearGradient';
import { Spacer } from 'emrn-design/Spacer';
import { rpx } from 'emrn-design/rpx';
import { Router } from 'emrn-hybrid/Router';
import React, { Component } from 'react';
import { StyleSheet, View, Text, Image, Platform } from 'react-native';

interface Props {
  tipText?: string;
  onPress?: Function;
  isApply?: boolean;
  level?: string;
  promWay?: string;
}

interface State {
  isShow: boolean;
}
/**
 * 账户抽奖次数限制
 * */
export class CountLimitPop extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      isShow: false,
    };
  }

  show = () => {
    this.setState({ isShow: true });
  };

  hide = () => {
    this.setState({ isShow: false });
  };
  handleApply = () => {
    if (Platform.OS === 'web') {
      return;
    }
    const { promWay } = this.props;
    let url = '';
    switch (promWay) {
      /**
       * 跳转中金所大赛
       * */
      case '1':
        if (Platform.OS === 'ios') {
          url = 'eastmoney://page/emrn?id=cffe';
        } else {
          url = 'dfcft://emrn?id=cffe';
        }
        break;
      /**
       * 学生认证
       * */
      case '2':
        if (Platform.OS === 'ios') {
          url = 'eastmoney://page/emrn?id=cffe&page=chooseAuth';
        } else {
          url = 'dfcft://emrn?id=cffe&page=chooseAuth';
        }
        break;
      // /**
      //  * 校园合伙人
      //  * */
      // case '0':
      // case '3':
      //   if (Platform.OS === 'ios') {
      //     url = 'eastmoney://page/opensafari?url=https://marketing.dfcfs.com/xyhd/campuspartner/index?fromAct=dsflg';
      //   } else if (Platform.OS === 'android') {
      //     url = 'dfcft://webh5?isAd=1&url=https://marketing.dfcfs.com/xyhd/campuspartner/index?fromAct=dsflg';
      //   }
      //   break;
    }
    openUrl(url);
  };
  render() {
    const { onPress, level, promWay } = this.props;
    const { isShow } = this.state;
    return (
      <>
        {isShow ? (
          <Mask>
            <View style={styles.content}>
              <LinearGradient
                start={{ x: 0, y: 0 }}
                end={{ x: 0, y: 0.19 }}
                colors={['#FFF7C2', '#FFFFFF']}
                style={styles.main}
              >
                <Spacer size={rpx(24)} />
                <Image
                  style={styles.countLimit}
                  source={require('../../images/invite/noticeBg.png')}
                  resizeMode={'stretch'}
                />
                <Spacer size={rpx(17)} />
                <View style={{ alignItems: 'center' }}>
                  <Text style={styles.centerText}>
                    当前<Text style={styles.centerRedText}>V{level}</Text>等级邀请抽奖次数已达上限，
                  </Text>
                  {level === '3' ? (
                    <Text style={styles.centerText}>感谢您的热情参与！</Text>
                  ) : (
                    <Text style={styles.centerText}>升级即可解锁更多机会！</Text>
                  )}
                  <Spacer size={rpx(30)} />
                  {level === '3' ? (
                    <View style={styles.btnKnow}>
                      <EmTouchableOpacity
                        onPress={() => {
                          onPress && onPress();
                          this.handleApply();
                          this.hide();
                        }}
                      >
                        <Image
                          style={styles.toUpgrade}
                          source={require('../../images/invite/knowBtn.png')}
                          resizeMode={'stretch'}
                        />
                      </EmTouchableOpacity>
                    </View>
                  ) : (
                    <View style={styles.btnGroup}>
                      <EmTouchableOpacity
                        onPress={() => {
                          onPress && onPress();
                          this.handleApply();
                          this.hide();
                        }}
                      >
                        <Image
                          style={styles.toUpgrade}
                          source={require('../../images/invite/toUpgrade.png')}
                          resizeMode={'stretch'}
                        />
                      </EmTouchableOpacity>
                      <EmTouchableOpacity
                        onPress={() => {
                          this.hide();
                        }}
                      >
                        <Image
                          style={styles.nextBtn}
                          source={require('../../images/invite/nextBtn.png')}
                          resizeMode={'stretch'}
                        />
                      </EmTouchableOpacity>
                    </View>
                  )}
                  <Spacer size={rpx(12)} />
                  {level !== '3' && (
                    <Text style={styles.bottomText}>
                      超出的抽奖次数可在 <Text style={styles.textYellow}>邀请进度</Text> 手动领取
                    </Text>
                  )}
                </View>
                <Spacer size={rpx(30)} />
              </LinearGradient>
              <EmTouchableOpacity
                onPress={() => {
                  this.hide();
                }}
              >
                <Image
                  style={styles.closeImg}
                  source={require('../../images/invite/closeBtn.png')}
                  resizeMode={'stretch'}
                />
              </EmTouchableOpacity>
            </View>
          </Mask>
        ) : null}
      </>
    );
  }
}

const styles = StyleSheet.create({
  content: {
    width: '100%',
    height: '100%',
    alignItems: 'center',
    justifyContent: 'center',
  },
  main: {
    width: rpx(300),
    backgroundColor: '#fff',
    borderRadius: rpx(32),
    alignItems: 'center',
  },
  centerText: {
    fontSize: rpx(15),
    color: '#333333',
    lineHeight: rpx(24),
    textAlign: 'justify',
    textAlignVertical: 'center',
  },
  centerRedText: {
    color: '#FF2233',
  },
  countLimit: {
    width: rpx(262),
    height: rpx(26),
    marginTop: rpx(10),
  },
  completeBtn: {
    width: rpx(133),
    height: rpx(41),
  },
  closeImg: {
    marginTop: rpx(20),
    width: rpx(56),
    height: rpx(41),
  },
  btnKnow: {
    width: rpx(275),
    flexDirection: 'row',
    justifyContent: 'center',
  },
  btnClose: {
    width: rpx(100),
    height: rpx(40),
    textAlign: 'center',
    lineHeight: rpx(40),
    borderRadius: rpx(5),
    backgroundColor: 'red',
  },
  btnGroup: {
    width: rpx(275),
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  toUpgrade: {
    width: rpx(133),
    height: rpx(41),
  },
  toAppend: { width: rpx(132), height: rpx(40) },
  nextBtn: {
    width: rpx(133),
    height: rpx(41),
  },
  bottomText: {
    fontSize: rpx(12),
    color: '#999999',
  },
  textYellow: {
    color: '#C8974A',
  },
});
